import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader, Icon, SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import { ModalForm } from './ModalForm';
export default function CreateAdminModal(_ref) {
  let trigger = _ref.trigger,
    triggerAdminRefresh = _ref.triggerAdminRefresh;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const SubmitButton = () => {
    return /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      variant: "contained",
      form: "create-account",
      disabled: isLoading || store.admin.createAdminAccountAsync.inProgress,
      'custom-attribute': '17-create-admin-modal'
    }, t('admin_page.create_account'));
  };
  useEffect(() => {}, []);
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "action",
    'custom-attribute': '18-create-admin-modal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "team-group"
  }), t('admin_page.add_new_admin_account'));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: defaultTrigger,
    title: t('admin_page.add_new_admin_account'),
    variant: "middle",
    rightButton: /*#__PURE__*/React.createElement(SubmitButton, null)
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading || store.admin.createAdminAccountAsync.inProgress
  }), /*#__PURE__*/React.createElement(ModalForm, {
    setIsLoadingExternal: setIsLoading,
    externalTrigger: trigger,
    triggerRefresh: triggerAdminRefresh
  }));
}